export const PatrickMacmurchy = () => {
  return (
    <div>
      {" "}
      <div
        className=""
        id="pmacmurchyModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="contactModalLabel"
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body" style={{ height: " 100%" }}>
              <div className="row">
                <div className="col-lg-4">
                  <img
                    className="profile-image"
                    src="/images/executioners/pmacmurchy.jpg"
                    alt="Patrick MacMurchy"
                    style={{ margin: "10px 0" }}
                  />
                </div>
                <div className="col-lg-8">
                  <div className="modal-title-container">
                    <h4 className="modal-title" id="contactModalLabel">
                      Patrick MacMurchy
                    </h4>
                    <p>Co-Founder, Atlas Data Solutions</p>
                    <p style={{ paddingTop: "17px" }}>
                      <strong>
                        "Failure is simply nature’s way of saying ‘try it
                        another way'"
                      </strong>
                    </p>
                  </div>
                  <div className="modal-body-container">
                    <p>
                      In his role of Founder and Chief Automation Officer,
                      Patrick has created systems to assist such clients as
                      Textbook Painting, Wes &amp; Willy Boys Apparel, Detroiter
                      Restaurants, and University Tees/ University Threads,
                      reach advanced levels of efficiency by automating manual
                      processes and tasks.
                    </p>
                    <p>
                      When asked to explain exactly how his process works,
                      Patrick said, “If we can save someone 1 penny on a process
                      they do 50 times a day or save a ½ second on a task that
                      happens 20 times a day, that adds up. It’s what our tag
                      line “Off your shoulders and on to ours” means.
                    </p>
                    <p>
                      Automating data is all about being unwilling to be bored.
                    </p>
                    <p>
                      If something has to be done more than once in any given
                      day, it should be automated so it sort of does itself.
                    </p>
                    <p>
                      Prior to creating Atlas, Patrick founded Squid Screen
                      Printing. His penchant for never repeating the boring has
                      grown his business from zero to a half a million dollar
                      valuation in a heartbeat.
                    </p>
                    <p>
                      Patrick graduated from Truman State College with a
                      Bachelor’s Degree in Performance Piano. Automating systems
                      gives him time to play everyday.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-default"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
